(() => {
  if (window.owStockShortcutReady) return;
  window.owStockShortcutReady = true;
  window.addEventListener('click', (event) => {
    const link = event.target.closest?.('.ow-stock-shortcut a');
    if (!link) return;
    const url = new URL(window.location.href);
    url.searchParams.set('filter.v.availability', '1');
    if (link.dataset.owBudget) {
      const ceiling = Number(link.dataset.owBudget);
      if (!Number.isFinite(ceiling) || ceiling <= 0) return;
      url.searchParams.set('filter.v.price.lte', String(ceiling));
      // Replace a conflicting previous price floor, retaining care filters and sort.
      if (Number(url.searchParams.get('filter.v.price.gte')) > ceiling) {
        url.searchParams.delete('filter.v.price.gte');
      }
    }
    url.searchParams.delete('page');
    link.href = url.href;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }, true);
})();
